exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1Za15{margin:0}._3l14C{color:#008489!important}@media screen and (max-width:743px){._170r4{display:none!important}}", ""]);

// exports
exports.locals = {
	"root": "_1Za15",
	"exitText": "_3l14C",
	"hideSm": "_170r4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Header/List/ListNavigation.css
// module id = 2536
// module chunks = 15